module.exports = __webpack_public_path__ + "static/media/default-user.d961d73a.png";